import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';


export function initGroupSwiper() {
  const groupSwiper = document.querySelector('.agricole-cards-swiper');
  if (!groupSwiper) {
    return;
  }

  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const groupSwiperConfig = {
    modules: [Navigation, Pagination],
    slidesPerView: 3.05,
    spaceBetween: 30,
    navigation: {
      nextEl: '.agricole-cards-swiper .swiper-button-next',
      prevEl: '.agricole-cards-swiper .swiper-button-prev',
    },
    pagination : {
      el: '.agricole-cards-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2.1,
        spaceBetween: 15,
      },
      1624: {
        slidesPerView: 3.05,
        spaceBetween: 20,
      },
    },
  };

  // Fix specifico per Chrome: aggiungi gestori di eventi per debugging
  if (isChrome) {
    groupSwiperConfig.on = {
      init: function() {
        console.log('🔍 Chrome: Swiper cantine inizializzato');
        
        // Aggiungi un marker specifico per Chrome per identificare meglio i link
        const slides = this.slides;
        slides.forEach((slide, index) => {
          slide.setAttribute('data-chrome-swiper-slide', index);
          const links = slide.querySelectorAll('a[href*="/cantine/"], a[href*="/wineries/"]');
          links.forEach(link => {
            link.setAttribute('data-chrome-cantina-link', 'true');
          });
        });
      },
      slideChange: function() {
        console.log('🔍 Chrome: Slide cambiata', this.activeIndex);
      },
      click: function(swiper, event) {
        console.log('🔍 Chrome: Click su Swiper', event.target);
        // Non preveniamo il comportamento di default per i link
        if (event.target.closest('a[href]')) {
          console.log('🔍 Chrome: Click su link dentro Swiper - permettendo navigazione');
        }
      }
    };
  }

  const swiperInstance = new Swiper('.agricole-cards-swiper', groupSwiperConfig);

  // Per Chrome, aggiungi un listener aggiuntivo sui link delle cantine nel Swiper
  if (isChrome) {
    setTimeout(() => {
      const cantinaLinks = groupSwiper.querySelectorAll('a[href*="/cantine/"], a[href*="/wineries/"]');
      cantinaLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          console.log('🔍 Chrome: Click su link cantina in Swiper', {
            href: this.href,
            slide: this.closest('.swiper-slide'),
            slideIndex: this.closest('.swiper-slide')?.getAttribute('data-chrome-swiper-slide')
          });
        }, { capture: true });
      });
    }, 100);
  }

  return swiperInstance;
}